<script>
import options from './CreateFolderOverlay.options'
export default options
</script>

<template>

  <div class="kb-overlay-styles__content-wrapper">

    <article class="kb-overlay-styles kb-create-folder-overlay" :class="{ 'kb-overlay-styles--submitting': isSubmitting }">
      
      <div class="kb-overlay-styles__wrapper-for-scroll-bottom">

        <div class="kb-overlay-styles__hero">
          <div class="kb-overlay-styles__hero-wrapper">
            <h4 class="kb-overlay-styles__hero-title">{{ getLabel('title') }}</h4>
          </div>
        </div>

        <div class="kb-overlay-styles__hero-curve">
          <svg role="presentation" viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
          </svg>
        </div>

        <div class="kb-overlay-styles__form-content kb-stafet-donation-flow">

          <section class="kb-stafet-step kb-optimizely-forms kb-stafet-donation-flow__step">
  
            <div class="kb-stafet-step__input-wrapper">
    
              <FormInputTextField
              isRequired
              v-model="itemName"
              fieldName="folderName"
              :modelValue="itemName"
              type="text"
              :label="getLabel('itemNameLabel')"
              :isValidationError="
                displayError && !nonEmptyStringValidator(itemName)
              "
              :placeholder="getLabel('itemNamePlaceholder')"
              :errorMessageLabel="getLabel('itemNameError')"
              />
    
            </div>

            <nav class="kb-stafet-flow-actions">
              <div class="kb-stafet-flow-actions__buttons-left-wrapper">
                <button class="kb-button kb-button--full-color-spot kb-button--full-color-spot"
                  v-on:click="submitCreateOrEditFolderOrFile">
                  {{ getLabel("submitItemButtonText") }}
                </button>
              </div>
            </nav>
  
          </section>

        </div>

      </div>

      <template v-if="isSubmitting">
        <div class="kb-spinner-overlay">
          <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
        </div>
      </template>
    </article>

  </div>
</template>
